import QrScanner from 'qr-scanner';
import React, { useEffect, useRef, useState } from "react";
import "react-medium-image-zoom/dist/styles.css";
import { toast } from "react-toastify";
import {
  Block,
  BlockBetween,
  BlockContent,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Row
} from "../../components/Component";
import { PreviewCard } from "../../components/preview/Preview";
import { getConfig } from "../../config";
import { POST } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { ACTION_SCAN, decryptBill } from "../../utils/Utils";

const { company } = getConfig();

const ScanBill = ({ history }) => {
  const videoRef = useRef();
  const qrScannerRef = useRef();
  const shouldNotScan = useRef(false);
  const [cameraList, setCameraList] = useState([]);
  const [cameraChoosed, setCameraChoosed] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    qrScannerRef.current = new QrScanner(
      videoRef.current,
      result => {
        if (result?.data) {
          if (!shouldNotScan.current) {
            actionScan(result?.data)
          }
        }
      },
      {
        highlightScanRegion: true,

      }
    );
    qrScannerRef.current.start().then(() => {
      QrScanner.listCameras(true).then(cameras => {
        setCameraList(cameras)
      });
    })
    return () => {
      qrScannerRef.current?.stop()
      qrScannerRef.current?.destroy()
    }
  }, []);

  const actionScan = (temp) => {
    try {
      shouldNotScan.current = true;
      const dataObj = decryptBill(temp)
      if (dataObj.action) {
        let path;
        if (dataObj.action === ACTION_SCAN.TIME_KEEPING) {
          path = `/self-employee/agree-keepingtime/${dataObj.data.id}`
        } else if (dataObj.action === ACTION_SCAN.OIL_OUT_INSIDE_TRANSACTION) {
          path = `/inventory/agree-oil-out-inside-transaction/${dataObj.data.id}`
        } else if (dataObj.action === ACTION_SCAN.PIECE_WAGE) {
          path = `/self-employee/agree-piece-wage/${dataObj.data.id}`
        }
        if (!path) {
          shouldNotScan.current = false;
          return
        }
        POST(path, {}, {}, true)
          .then(() => {
            setIsSuccess(true);
          })
          .catch(({ response }) => {
            toast.error(
              (response?.data?.error || "Có lỗi xảy ra") + ".  Vui lòng thử lại sau 3s"
            );
            setTimeout(() => {
              shouldNotScan.current = false;
            }, 3000);
          })
      } else if (dataObj.billId && dataObj.companyId) {
        if (['TL', 'CT'].includes(company)) {
          history.push(`/bill/update-by-scaler/${temp}`);
        } else {
          history.push(`/pn-bill/update-by-weighing-slip/${temp}`);
        }
      } else {
        shouldNotScan.current = false;
      }
    } catch (error) {
      shouldNotScan.current = false;
    }

  }


  return (
    <React.Fragment>
      <Head title="Quét chấm công"></Head>

      <Content>
        <Block size="lg">
          <BlockHead size="sm">
            <BlockBetween className="g-3">
              <BlockHeadContent>
                <BlockTitle page>
                  <strong className="small">Quét chấm công</strong>
                </BlockTitle>
              </BlockHeadContent>
            </BlockBetween>
          </BlockHead>
          <PreviewCard>
            <Block>
              <Row className={`gy-5 ${isSuccess ? 'd-none' : ''}`}>
                <Col lg="12">
                  <BlockHead>
                    <BlockHeadContent>
                      <BlockTitle tag="h5">Quét mã QR</BlockTitle>
                    </BlockHeadContent>
                  </BlockHead>
                  <Row>
                    <div className="d-flex justify-content-center align-items-center flex-column">
                      <div className="w-100">
                        <select
                          placeholder="Vui lòng chọn video"
                          className="form-control mb-2"
                          value={cameraChoosed}
                          onChange={(e) => {
                            setCameraChoosed(e.target.value);
                            qrScannerRef.current.setCamera(e.target.value)
                          }}
                        >
                          <option value="environment" selected>Environment Facing (default)</option>
                          {cameraList.map((e) => (
                            <option key={e.id} value={e.id}>
                              {e.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div style={{ maxWidth: 480 }}>
                        <video ref={videoRef} width={'100%'}></video>
                      </div>
                    </div>
                  </Row>
                </Col>
              </Row>
              {isSuccess
                ? <Row>
                  <Col lg="12">
                    <BlockHead>
                      <BlockHeadContent>
                        <BlockTitle tag="h5">Cập nhật thành công</BlockTitle>
                        <BlockContent>Bấm vào <Button onClick={() => {
                          setIsSuccess(false);
                          shouldNotScan.current = false;
                        }}>Đây</Button> để tiếp tục scan</BlockContent>
                      </BlockHeadContent>
                    </BlockHead>
                  </Col>
                </Row>
                : ''}
            </Block>
          </PreviewCard>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default ScanBill;
